import React, { useEffect, useState, useRef } from "react";
import { Modal, theme, Popconfirm, Tooltip } from "antd";
import { URL_SETTING } from "../../../constants/urls";
import ErrorMessages from "../../../common/ErrorMessages";
import TSTable from "../../../common/TSTable";
import { DELETE } from "../../../frameworks/HttpClient";
import { dateTimeToHumanString } from "../../../frameworks/Util";
import ColorButton from "../../../common/ColorButton";
import {
  DeleteOutlined,
  EditOutlined,
  PlusCircleFilled,
} from "@ant-design/icons";
import ShippingModalDetail from "./ShippingModalDetail";
import CustomDeleteConfirmButton from "../../../common/CustomDeleteConfirmButton";

export default function ShippingModalLocation(props) {
  const { isDone } = props;
  const [openDetailModal, setOpenDetailModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState(null);
  const tableRef = useRef(null);
  const [target, setTarget] = useState(null);
  const { open, onClose } = props;

  const [tableUrl, setTableUrl] = useState(`${URL_SETTING.SHIPPING_ADDRESS}`);

  useEffect(() => {
    if (props.target?.id) {
      const buyerId = props.target.id;
      setTableUrl(`${URL_SETTING.SHIPPING_ADDRESS}?buyer=${buyerId}`);
    }
  }, [props.target]);

  const refreshData = async () => {
    if (tableRef.current) {
      await tableRef.current.fetchWithoutResetPage();
    }
  };

  const {
    token: { colorWarning, colorError, colorSuccess , coloprimary },
  } = theme.useToken();

  const handleEdit = (record) => {
    if (!record?.id) return;
    setTarget(record);
    setOpenDetailModal(true);
  };

  const handleDelete = async (id) => {
    if (!id) return;
    try {
      await DELETE(`${URL_SETTING.SHIPPING_ADDRESS}${id}/`);
      refreshData();
    } catch (error) {}
  };

  const columns = [
    {
      title: "Action",
      dataIndex: "",
      width: 200,
      key: "action",
      align: "center",
      render: (_, record) =>
        !isDone && (
          <div onClick={(e) => e.stopPropagation()}>
            <CustomDeleteConfirmButton
              title={`ยืนยันลบหรือไม่`}
              content={"ยืนยันการลบรายการนี้หรือไม่ ?"}
              onOk={ async() => {
                await handleDelete(record.id)
                refreshData();
              }}
              onConfirm={() => refreshData()}
            />
            <Tooltip trigger="hover" title="แก้ไขข้อมูล">
              <ColorButton
                type="primary"
                override={colorWarning}
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
                style={{ margin : 5}}
              />
            </Tooltip>
          </div>
        ),
    },
    {
      title: "ที่อยู่ส่งสินค้า",
      dataIndex: "address",
      key: "address",
      ellipsis: true,
      align: "center",
    },
    {
      title: "ชื่อผู้ติดต่อ",
      dataIndex: "contact",
      key: "contact",
      align: "center",
    },
    {
      title: "เบอร์โทรติดต่อ",
      dataIndex: "phone",
      key: "phone",
      align: "center",
    },
    {
      title: "วันที่สร้าง",
      dataIndex: "created",
      key: "created",
      align: "center",
      render: (value) => dateTimeToHumanString(value),
    },
  ];

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <div>
      <Modal
        open={open}
        onCancel={onClose}
        title={"ที่อยู่ส่งสินค้า"}
        width={800}
        destroyOnClose
        centered
        footer={[
          <ColorButton
            key="close"
            style={{ marginTop: 10 }}
            onClick={onClose}
          >
            ปิด
          </ColorButton>,
        ]}
      >
        <ColorButton
          override={colorSuccess}
          type="primary"
          style={{ marginBottom: 10, float: "right" }}
          icon={<PlusCircleFilled />}
          onClick={() => setOpenDetailModal(true)}
        >
          เพิ่มที่อยู่ส่งสินค้า
        </ColorButton>
        <TSTable columns={columns} size="small" url={tableUrl} ref={tableRef} />

        <ErrorMessages message={errorMessages} />
        <ShippingModalDetail
          open={openDetailModal}
          onClose={() => {
            setOpenDetailModal(false);
            setTarget(null);
          }}
          target={target}
          onUpdate={() => {
            setOpenDetailModal(false);
            setTarget(null);
            refreshData();
          }}
          buyerId={props.target?.id}
        />
      </Modal>
    </div>
  );
}
